// ArticleService.js
import axios from "axios";
import { ApiLink } from "../APILink/ApiLink";
import authHeader from "../Auth/authHeader";

// const API_URL = "/api/articles/pick";

export async function fetchArticles({ search = "", page = 1, pageSize = 50, salesTypeId }) {
  const headers = authHeader();

  const response = await axios.get(ApiLink.API_URL + "Article/pick", {
    headers,
    params: { search, page, pageSize, salesTypeId },
  });

  return response.data;
}

export async function fetchVatRates() {
  try {
    const response = await axios.get(ApiLink.API_URL + "vatrates", {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}


